module.exports = __webpack_public_path__ + "img/img_4.7c90bb96.jpeg";